﻿

// ------------------------------------------------------------------------- //
// #MACHINE
// ------------------------------------------------------------------------- //


window.farmday = window.farmday || {};
farmday.modules = farmday.modules || {};


farmday.modules.machine = (function () {
    var priv = {};


    /**
     * Private initialization method
     */
    priv.init = function () {
        if ($(".js-page-identifier-machine").length) {
            $(".modal-trigger").click(function (event) {
                var modalId = event.target.dataset.triggerModal;
                $("#" + modalId).removeClass("hidden");
            });

            $("#add-machine-cancel").click(function () {
                var url = $(".js-page-identifier-machine").data("url");

                if (url !== "" && url !== undefined) {
                    location.href = url;
                }
            });
        }
    };


    // Initialize module
    $(function () {
        priv.init();
    });

})();
